
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/business-days-calculator",
      function () {
        return require("private-next-pages/calculators/business-days-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/business-days-calculator"])
      });
    }
  